import { create } from 'zustand';
export const useUIStore = create((set) => ({
    sidebarOpen: true,
    mobileMenuOpen: false,
    currentModule: 'dashboard',
    modalOpen: false,
    toggleSidebar: () => set((state) => ({ sidebarOpen: !state.sidebarOpen })),
    setSidebarOpen: (open) => set({ sidebarOpen: open }),
    setMobileMenuOpen: (open) => set({ mobileMenuOpen: open }),
    setCurrentModule: (module) => set({ currentModule: module }),
    setModalOpen: (open) => set({ modalOpen: open }),
}));
